import { render } from "./PathSelector.vue?vue&type=template&id=3a57c1e7&scoped=true"
import script from "./PathSelector.vue?vue&type=script&lang=js"
export * from "./PathSelector.vue?vue&type=script&lang=js"

import "./PathSelector.vue?vue&type=style&index=0&id=3a57c1e7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a57c1e7"]])

export default __exports__